import moment from 'moment';
import React from 'react';

import { useOrientation } from '@/lib/hooks/useOrientation';

import styles from './index.module.scss';

const TimeAndStatus = ({ status, createdTime }) => {
  const orientation = useOrientation();
  const isLandscape = orientation === 'LANDSCAPE';

  return (
    <div className={styles.timeAndStatus}>
      {isLandscape ? (
        <>
          <div
            className={
              status === '未領取' ? styles.unreceived : styles.received
            }
          >
            {status}
          </div>
          <p>{moment(createdTime).format('YYYY-MM-DD HH:mm:ss')}</p>
        </>
      ) : (
        <>
          <p>{moment(createdTime).format('YYYY-MM-DD HH:mm:ss')}</p>
          <div
            className={
              status === '未領取' ? styles.unreceived : styles.received
            }
          >
            {status}
          </div>
        </>
      )}
    </div>
  );
};

export default TimeAndStatus;
